import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1638543912/src/toppan-voice-recorder-frontend/layouts/default.vue").then(m => m.default || m))
}